import { MasterTaskTool } from './master-task-tool';

export class MasterTask {

  constructor(
    public hash?: string,
    public name?: string,
    public identifier?: string,
    public masterTaskTools?: MasterTaskTool[],
    public adapter?: string,
    public adapterName?: string
  ) { }

  clone() {
    return new MasterTask(
      this.hash,
      this.name,
      this.identifier,
      this.masterTaskTools,
      this.adapter,
      this.adapterName
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/master-task.ts